import {useState} from "react";
import {ApiBusinessProto, com} from "../../provider_api";
import {useRpcSender} from "../RpcSender";
import {useProviderProfile} from "../../ProviderProfileProvider";
import {RpcState} from "../RpcState";
import GetStripeAccountStatusResponse = com.onkensu.platform.billing.GetStripeAccountStatusResponse;

export const useStripeMembershipStatusRpc = () => {

  const rpcSender = useRpcSender();
  const {business, setBusiness} = useProviderProfile();
  const [rpcState, setRpcState] = useState<RpcState>({state: "none"});

  const send = () => {

    setRpcState({state: 'pending'});
    rpcSender.send('get_stripe_account_status', new Uint8Array())
        .then(r => {
          const response = GetStripeAccountStatusResponse.decode(r);
          if (!response.okay) {
            setRpcState({state: 'error', message: 'error fetching stripe account'});
            return;
          }

          setBusiness(new ApiBusinessProto({
            ...business,
            connectedAccountStatus: response.updatedAccountStatus
          }));
          setRpcState({state: 'success'});

        })
        .catch(e => {
          setRpcState({state: 'error', message: e});
        })
  }

  return {rpcState, send};
}